import { capitalize, displayMembershipCode } from "../../../../assets/helpers/funciones";
import { ActionButton } from "../../../common/Buttons/Buttons"


export const MultipleVehiclesTable = ({ table }) => {
    const { header, data, actions, curentStep, clientNumber, payments } = table;

    if (data.length === 0) {
        return null
    }

    const sumTotal = (data) => {
        let total = 0

        for (let i = 0; i < data.length; i++) {
            total = total + data[i].priceInfo.finalPrice
        }
        return total
    }

    return (
        <>
            <h5 style={{ marginTop: '12px', textAlign: "center" }}>Resumen</h5>
            <table style={{ marginBottom: "24px" }} className="table payments-table">
                <tr>
                    {header?.map((h, i) => {
                        if (i === header.length - 1 && ![2, 3].includes(curentStep)) {
                            return null
                        }
                        return (
                            <th
                                key={h?.name + i}
                                style={{ display: h?.hide ? 'none' : '' }}
                            >
                                {h?.name}
                            </th>
                        )
                    })}
                </tr>

                {data?.map((d, i) => (
                    <tr style={{ backgroundColor: i === clientNumber ? "#f27730" : "" }} key={i}>
                        <td >
                            <p style={{ margin: "0px", backgroundColor: i === clientNumber ? "#f27730" : "" }}> <b style={{ marginBottom: "12px", fontSize: "14px", }}>Membresia {i + 1}</b><br />
                                <b>Clase:</b> {d?.dataTable?.class}<br />
                                <b>Plan:</b>{' '}
                                {capitalize(
                                  displayMembershipCode(d?.dataTable?.plan)
                                )}
                                <br />
                                <b>Año:</b> {d?.dataTable?.year}<br />
                                <b>RCV:</b> {d?.dataTable?.rcv} <br /><br />
                                <b>Monto: {d?.priceInfo?.finalPrice}$ </b>
                            </p>
                        </td>
                        <td>
                            {d.customer &&
                                <p style={{ margin: "0px", backgroundColor: i === clientNumber ? "#f27730" : "" }}> <b style={{ marginBottom: "12px", fontSize: "14px", }}>{d?.customer?.firstName + " " + d?.customer?.lastName}</b><br />
                                    {d?.customer?.identificationType + "-" + d?.customer?.identification}<br />
                                    {d?.customer?.phonePrefix + "-" + d?.customer?.phoneNumber}<br />
                                    {d?.customer?.email} <br />
                                </p>
                            }
                        </td>
                        <td>
                            {d.vehicle &&
                                <p style={{ margin: "0px", backgroundColor: i === clientNumber ? "#f27730" : "" }}> <b style={{ marginBottom: "12px", fontSize: "14px", }}>{d?.vehicle?.plate}</b><br />
                                    {d?.dataTable?.brand + " " + d?.dataTable?.model}<br />
                                    {d?.dataTable?.state + ", " + d?.dataTable?.city + ", " + d?.dataTable?.municipality + ", " + d?.dataTable?.address}<br />
                                </p>
                            }
                        </td>
                        {[2, 3].includes(curentStep) &&
                            <td style={{ width: "250px" }} >
                                <div style={{ alignItems: "center", display: "flex", justifyContent: "center", backgroundColor: i === clientNumber ? "#f27730" : "" }}>
                                    {[2, 3].includes(curentStep) && d.customer && <ActionButton label={"Editar Cliente"} action={() => actions.editClient(i)} />}
                                    {[2, 3].includes(curentStep) && !d.customer && <ActionButton label={"Agregar Cliente"} action={() => actions.addClient(i)} />}


                                    {[3].includes(curentStep) && d.vehicle && <ActionButton label={"Editar Vehículo"} action={() => actions.editVehicle(i)} />}
                                    {[3].includes(curentStep) && !d.vehicle && <ActionButton label={"Agregar Vehículo"} action={() => actions.addVehicle(i)} />}
                                </div>
                            </td>
                        }
                    </tr >
                ))}
                <tr>
                    <td>
                        {payments?.length > 0 &&
                            <div style={{ textAlign: "center" }} >
                                {payments.map((p, i) =>
                                    <p style={{ margin: 0 }}><b>{capitalize(p?.methodName)}</b>{": " + p?.amount + "$ " +
                                        p?.amountBsS + "Bs"}</p>)}
                            </div>
                        }
                        <b style={{ fontSize: "18px" }}>
                            Total: {sumTotal(data)}$</b></td>
                    <td></td>
                    <td></td>
                    {[2, 3].includes(curentStep) &&
                        <td></td>
                    }
                </tr>
            </table >
        </>
    )
};
